export const CONTACT_EMAIL = "contact@lutuu.ro";
export const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSeaoYZzBQVLCj-x9HuJ8CWDPF3Ro6H31oycOls0jNYHd92Cqg/viewform?usp=dialog";
export const TIKTOK_URL = "https://www.tiktok.com/@imlutuu";
export const FACEBOOK_URL = "https://www.facebook.com/share/1X7trZg6RL/";
export const YOUTUBE_URL = "https://youtube.com/@imlutuu99?si=qE51l5FSx0V3pmqv";
export const SNAPCHAT_URL = "https://snapchat.com/t/2yv80msB";
export const INSTAGRAM_URL = "https://www.instagram.com/scurtunelutu?vrfl=MXZuMWlocm1jeWR2dw%3D%3D&utm_source=qr";
